import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime-corejs3/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { useState } from 'react';
var StepOutOfRangeError = /*#__PURE__*/function (_Error) {
  _inherits(StepOutOfRangeError, _Error);
  var _super = _createSuper(StepOutOfRangeError);
  function StepOutOfRangeError() {
    _classCallCheck(this, StepOutOfRangeError);
    return _super.call(this, 'Step must be in range 0..3');
  }
  return _createClass(StepOutOfRangeError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var useEnrollmentSteps = function useEnrollmentSteps() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var stepForward = function stepForward() {
    if (step >= 3) throw new StepOutOfRangeError();
    setStep(step + 1);
  };
  var stepBackward = function stepBackward() {
    if (step <= 0) throw new StepOutOfRangeError();
    setStep(step - 1);
  };
  var goToStep = function goToStep() {
    var newStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (newStep < 0 || newStep > 3) throw new StepOutOfRangeError();
    setStep(newStep);
  };
  return {
    step: step,
    stepForward: stepForward,
    stepBackward: stepBackward,
    goToStep: goToStep
  };
};
//# sourceMappingURL=useEnrollmentSteps.js.map